export default {
  init() {
    // JavaScript to be fired on the return order page
    $('.order-line .reason-select select').select2();

    $('.order-line input[type="checkbox"]').change(function () {
      let form = $(this).closest('form');
      updateReturnForm(form);
    });

    $('.order .return-cancel').click(function () {
      let form = $(this).closest('form');
      form.find('.order-line input:checked').prop('checked', false );
      updateReturnForm(form);
    });

    $('.order').each(function () {
      let form = $(this).closest('form');
      updateReturnForm(form);
    });

    $('.return-submit').on('click', function() {
      $(this).prop('disabled', true);
    });
  },
  finalize() {
    // JavaScript to be fired on the return order page, after the init JS
  },
};

export var updateReturnForm = (form) => {
  let order = form.find('.order');
  let count = order.find('.order-line input:checked').length;
  let submitBar = order.find('.submit-bar');
  submitBar.find('.return-counter .counter').text(count);

  if (count > 0) {
    submitBar.slideDown();
  } else {
    submitBar.slideUp();
  }
}
